import { activeLocaleTag } from "@/i18n";

/**
 * A language's name ("de-DE" → "Deutsch (Deutschland)"), in the app language
 * unless `locale` names another - the language itself for its own name.
 * `fallback` where the runtime has no name for it, or the tag is malformed
 * (`Intl.DisplayNames` throws on those, and a name is not worth an error).
 */
export function languageDisplayName(
  tag: string,
  fallback = tag,
  locale: string = activeLocaleTag(),
): string {
  if (!tag) return fallback;
  try {
    return (
      new Intl.DisplayNames([locale], {
        type: "language",
        languageDisplay: "standard",
        fallback: "none",
      }).of(tag) ?? fallback
    );
  } catch {
    return fallback;
  }
}
